
    import './styles.scoped.css';
    export default {
  "progress": "awsui_progress_11huc_138xi_13",
  "result-state": "awsui_result-state_11huc_138xi_27",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_11huc_138xi_1",
  "root": "awsui_root_11huc_138xi_67",
  "with-result-button": "awsui_with-result-button_11huc_138xi_103",
  "result-text": "awsui_result-text_11huc_138xi_107",
  "result-container-error": "awsui_result-container-error_11huc_138xi_111",
  "result-container-success": "awsui_result-container-success_11huc_138xi_111",
  "result-button": "awsui_result-button_11huc_138xi_115",
  "word-wrap": "awsui_word-wrap_11huc_138xi_121",
  "label-flash": "awsui_label-flash_11huc_138xi_126",
  "label-key-value": "awsui_label-key-value_11huc_138xi_130",
  "flash": "awsui_flash_11huc_138xi_138",
  "progress-container": "awsui_progress-container_11huc_138xi_142",
  "percentage-container": "awsui_percentage-container_11huc_138xi_149",
  "percentage": "awsui_percentage_11huc_138xi_149",
  "percentage-flash": "awsui_percentage-flash_11huc_138xi_170",
  "complete": "awsui_complete_11huc_138xi_206",
  "progress-flash": "awsui_progress-flash_11huc_138xi_219",
  "additional-info": "awsui_additional-info_11huc_138xi_232"
};
  